class ConfigService {
  constructor() {
    this._config = {};
    this._secureConfig = {};
    this._isLoaded = false;
    this._isSecureConfigLoaded = false;
  }

  async load() {
    if (this._isLoaded) {
      return;
    }

    try {
      const fetchJson = async (path) => {
        try {
          const res = await fetch(path, { cache: "no-cache" });
          if (!res.ok) return null;
          return await res.json();
        } catch (_) {
          return null;
        }
      };

      let data = await fetchJson("/config.json");
      if (!data) {
        data = await fetchJson("/config.dev.json");
      }
      if (!data) {
        throw new Error("Failed to fetch config.json (and config.dev.json fallback)");
      }

      console.log("Configuration loaded successfully:", data);
      this._config = data;
      this._isLoaded = true;
    } catch (error) {
      console.error("CRITICAL: Could not load app configuration!", error);
      throw error;
    }
  }

  async loadSecureConfig(apiFunction) {
    try {
      const response = await apiFunction();

      if (response.data) {
        this._secureConfig = response.data;
        this._isSecureConfigLoaded = true;
        localStorage.setItem("secureConfig", JSON.stringify(response.data));
        console.log("Secure configuration loaded successfully");
      }
    } catch (error) {
      console.error("Failed to load secure configuration:", error);

      const stored = localStorage.getItem("secureConfig");
      if (stored) {
        try {
          this._secureConfig = JSON.parse(stored);
          this._isSecureConfigLoaded = true;
        } catch (e) {
          console.error("Failed to parse stored secure config:", e);
        }
      }
    }
  }

  loadSecureConfigFromStorage() {
    const stored = localStorage.getItem("secureConfig");
    if (stored) {
      try {
        this._secureConfig = JSON.parse(stored);
        this._isSecureConfigLoaded = true;
      } catch (e) {
        console.error("Failed to parse stored secure config:", e);
      }
    }
  }

  clearSecureConfig() {
    this._secureConfig = {};
    this._isSecureConfigLoaded = false;
    localStorage.removeItem("secureConfig");
  }

  get(key) {
    if (!this._isLoaded) {
      console.warn(`Config service has not been loaded yet, but tried to access key: "${key}"`);
    }

    // Priority: secure config > public config
    // This allows secure values to override public ones, but an empty secure
    // value (e.g. ldSdkKey: "") should not shadow a valid public value.
    // `/app-config` returns "" for every environment variable the backend has
    // unset, so an empty value means "not configured here", not "use this".
    if (this._isSecureConfigLoaded && key in this._secureConfig) {
      const secureValue = this._secureConfig[key];
      if (secureValue !== "" && secureValue !== null && secureValue !== undefined) {
        return secureValue;
      }
    }

    return this._config[key];
  }

  isSecureConfigLoaded() {
    return this._isSecureConfigLoaded;
  }
}

const instance = new ConfigService();
export default instance;
